<ng-template #templateToast>
  <div [class]="'custom-toast ' + type">
    <div class="custom-toast__left-column">
      <img class="custom-toast__icon" [src]="toastIconSrc" alt="toast-type" />
      <span class="custom-toast__message" [innerHtml]="message | translate"></span>
    </div>
    <div class="custom-toast__right-column">
      <ng-content select="[action-button]"></ng-content>
      <button class="custom-toast__close-button btn btn-link" (click)="closeToast()">
        <img src="assets/icons/icon_close_gray.svg" alt="close button" />
      </button>
    </div>
  </div>
</ng-template>
